import { render, staticRenderFns } from "./CandidateCourseType.vue?vue&type=template&id=c24d711c&lang=pug&"
import script from "./CandidateCourseType.vue?vue&type=script&lang=js&"
export * from "./CandidateCourseType.vue?vue&type=script&lang=js&"
import style0 from "./CandidateCourseType.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VSpacer})
